<template>
  <li
    v-if="canViewVerticalNavMenuLink(item)"
    class="nav-item"
    :class="{
      'active': isActive,
      'disabled': item.disabled
    }"
  >
    <drag
      :key="item.key"
      v-b-tooltip.hover.right.v-primary
      :title="item.title"
      :data="item"
      @dragstart="dragStart"
      @dragend="dragEnd"
    >
      <b-link
        v-bind="linkProps"
        class="d-flex align-items-center menudrag"
        style="cursor:grab"
      >
        <feather-icon
          :icon="item.icon || 'CircleIcon'"
          :style="'color:' + item.color"
        />
        <span class="menu-title text-truncate"> {{ t(item.title) }}</span>
        <b-badge
          v-if="item.tag"
          pill
          :variant="item.tagVariant || 'primary'"
          class="mr-1 ml-auto"
        >
          {{ item.tag }}
        </b-badge>
      </b-link>
    </drag>
  </li>
</template>

<script>
import { mapGetters } from 'vuex'
import store from '@/store'
import { useUtils as useAclUtils } from '@core/libs/acl'
import { BLink, BBadge, VBTooltip } from 'bootstrap-vue'
import { Drag } from 'vue-easy-dnd'
import { useUtils as useI18nUtils } from '@core/libs/i18n'
import useVerticalNavMenuLink from './useVerticalNavMenuLink'
import mixinVerticalNavMenuLink from './mixinVerticalNavMenuLink'

export default {
  components: {
    BLink,
    BBadge,
    Drag,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  mixins: [mixinVerticalNavMenuLink],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { isActive, linkProps, updateIsActive } = useVerticalNavMenuLink(props.item)
    const { t } = useI18nUtils()
    const { canViewVerticalNavMenuLink } = useAclUtils()

    return {
      isActive,
      linkProps,
      updateIsActive,

      // ACL
      canViewVerticalNavMenuLink,

      // i18n
      t,
    }
  },
  computed: {
    ...mapGetters([
      'dragAvailable',
    ]),
  },
  methods: {
    dragStart() {
      store.commit('drag/dragAvailable', true)
    },
    dragEnd() {
      // store.commit('drag/dragAvailable', false)
    },
  },
}
</script>
<style>
.menudrag{
    background: #161d314d!important;
    border-radius: 5px !important;
    margin-bottom: 4px;
}
.navigation li a.menudrag svg {
  width: 11px!important;
  height: 11px!important;
}
</style>
